import * as React from 'react';
import {connect} from 'react-redux';

import PatientPayment from '../../screens/Patients/PatientPayment';
import {
  PatientPaymentList,
  PatientPaymentSelectedPage,
  PatientPaymentStatusChange,
  PatientpaySlectedPage,
  PatientRefundStatusChange,
} from './action';
class PatientPaymentContainer extends React.Component<Props, State> {
  render() {
    return (
      <PatientPayment
        patientPaymentList={this.props.PatientPaymentList}
        patientPaymentDtlsList={this.props.patientPaymentDtlsList}
        patientPaymentDtlsCount={this.props.patientPaymentDtlsCount}
        patientPaymentSelectedPage={this.props.PatientPaymentSelectedPage}
        PatientPaymentStatusChange={this.props.PatientPaymentStatusChange}
        PatientPaymentSearch={this.props.PatientPaymentSearch}
        PatientPaymentSearchSelectedPage={
          this.props.PatientPaymentSearchSelectedPage
        }
        patientPaymentSearchList={this.props.patientPaymentSearchList}
        patientPaymentSearchCount={this.props.patientPaymentSearchCount}
        FliterSearchPatientPayment={this.props.FliterSearchPatientPayment}
        fltrPatientPaymentPagetn={this.props.fltrPatientPaymentPagetn}
        patientPaymentFilterList={this.props.patientPaymentFilterList}
        patientPaymentFilterCount={this.props.patientPaymentFilterCount}
        PatientpaySlectedPage={this.props.PatientpaySlectedPage}
        PatientRefundStatusChange={this.props.PatientRefundStatusChange}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    PatientPaymentList: value => {
      dispatch(PatientPaymentList(value));
    },

    PatientpaySlectedPage: value => {
      dispatch(PatientpaySlectedPage(value));
    },
    PatientPaymentSelectedPage: value => {
      dispatch(PatientPaymentSelectedPage(value));
    },
    PatientPaymentStatusChange: value => {
      dispatch(PatientPaymentStatusChange(value));
    },
    PatientRefundStatusChange: value => {
      console.log('value%%%%%%value%%%%%%', value);
      dispatch(PatientRefundStatusChange(value));
    },
  };
}
function mapStateToProps(state) {
  return {
    patientPaymentDtlsList: state.PatientPaymentReducer.patientPaymentDtlsList,
    patientPaymentDtlsCount:
      state.PatientPaymentReducer.patientPaymentDtlsCount,
  };
}

export default connect(mapStateToProps, bindAction)(PatientPaymentContainer);
